module.exports = __webpack_public_path__ + "img/pr_main.3e8da2ce.png";